import { api, setConfig } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const activateGames = (data: PropertyType): Promise<string | void> =>
	api.post('/games/enable', mapEntityToApi(data), setConfig(data)).then(() => {
		return 'The games have been successfully enabled';
	});
